// extracted by mini-css-extract-plugin
export default {"mainPanel":"Main_mainPanel__zt8ym"};